import { render } from "./CIS-List-Page-Hero.vue?vue&type=template&id=279dce98&scoped=true"
import script from "./CIS-List-Page-Hero.vue?vue&type=script&lang=js"
export * from "./CIS-List-Page-Hero.vue?vue&type=script&lang=js"

import "./CIS-List-Page-Hero.vue?vue&type=style&index=0&id=279dce98&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-279dce98"]])

export default __exports__